import { injectIntl } from 'react-intl';

import { showConfirmationModal, hideConfirmationModal } from '../actions/App';
import store from '../storeProvider';

const getConfirmation = (message, callback, intl) => {
  const modalParams = {
    title: intl.formatMessage({ defaultMessage: `Don't forget to save!` }),
    text: message,
    confirmText: intl.formatMessage({ defaultMessage: 'Yes' }),
    cancelText: intl.formatMessage({ defaultMessage: 'No' }),
    onConfirm: () => {
      store.dispatch(hideConfirmationModal());
      callback(true);
      return Promise.resolve();
    },
    onCancel: () => {
      callback(false);
      return Promise.resolve();
    },
  };

  store.dispatch(showConfirmationModal(modalParams));
};

export default injectIntl(getConfirmation);
